var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nebButton",class:[
    _vm.type,
    {
      disabled: _vm.disabled,
      icon: _vm.icon !== ''
    }
  ],on:{"click":_vm.onClick}},[(_vm.icon !== '')?_c('neb-icon',{attrs:{"name":_vm.icon,"height":"20px","width":"20px"}}):_vm._e(),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }